import * as api from '../connectivity/api.dropboxes';
import { call, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import * as types from '../constants/actionTypes';
import { showLoading, hideLoading } from 'react-redux-loading-bar';


export function* doRequestDropboxes(action) {
    yield put(showLoading());

    try {
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'dropboxes.doRequestDropboxes',
            }
        });

        const dropboxes = yield call(api.fetchDropboxes);

        yield put({
            type: types.DROPBOXES__REQUESTED__SUCCEEDED,
            payload: { dropboxes }
        });
    } catch (e) {
        yield put({
            type: types.DROPBOXES__REQUESTED__FAILED,
            message: e.message,
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'dropboxes.doRequestDropboxes',
        }
    });

    yield put(hideLoading());
}

export function* doRequestDropboxesSucceeded() {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'dropboxes.doRequestDropboxes',
        }
    });
}

export function* doRequestDropboxesFailed() {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'dropboxes.doRequestDropboxes'
        }
    });
}

export function* doRequestUpdateDropboxShowIndex(action) {
    yield put(showLoading());

    try{
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'dropboxes.doRequestUpdateDropboxShowIndex',
            }
        });

        yield call(api.updateDropbox, action.payload.dropbox);

        yield put({
            type: types.DROPBOXES__UPDATE__SHOW_INDEX__REQUESTED__SUCCEEDED,
        });
    } catch (e) {
        yield put({
            type: types.DROPBOXES__UPDATE__SHOW_INDEX__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'dropboxes.doRequestUpdateDropboxShowIndex',
        }
    });

    yield put(hideLoading());
}

export function* doRequestUpdateShowIndexDropboxesSucceeded() {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'dropboxes.doRequestUpdateDropboxShowIndex',
        }
    });
}

export function* doRequestUpdateDropboxesShowIndexFailed() {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'dropboxes.doRequestUpdateDropboxesShowIndex'
        }
    });
}


export function* watchRequestDropboxes() {
    yield* takeLatest(types.DROPBOXES__REQUESTED, doRequestDropboxes);
}
export function* watchRequestDropboxesSucceeded() {
    yield* takeLatest(types.DROPBOXES__REQUESTED__SUCCEEDED, doRequestDropboxesSucceeded);
}

export function* watchRequestDropboxesFailed() {
    yield* takeLatest(types.DROPBOXES__REQUESTED__FAILED, doRequestDropboxesFailed);
}

export function* watchRequestUpdateDropboxShowIndex() {
    yield* takeLatest(types.DROPBOXES__UPDATE__SHOW_INDEX__REQUESTED, doRequestUpdateDropboxShowIndex);
}

export function* watchRequestUpdateDropboxShowIndexSucceeded() {
    yield* takeLatest(types.DROPBOXES__UPDATE__SHOW_INDEX__REQUESTED__SUCCEEDED, doRequestUpdateShowIndexDropboxesSucceeded);
}

export function* watchRequestUpdateDropboxShowIndexFailed() {
    yield* takeLatest(types.DROPBOXES__UPDATE__SHOW_INDEX__REQUESTED__FAILED, doRequestUpdateDropboxesShowIndexFailed);
}


/** WEBPACK FOOTER **
 ** ./src/sagas/dropboxes.saga.js
 **/